export default __webpack_public_path__ + "static/media/EM1650.34I-38825_-22770_0.13ed59ca.jpg";